import { Injectable } from "@angular/core";
import { select } from "@ngrx/store";
import { AUTH_ROUTE, CORE_ROUTE, CoreState, Message, MessageFilter, MessageSelector } from "@obg/ngx.core";
import { RouteSelector } from "@obg/ngx.router";
import { asyncScheduler, combineLatest, Observable } from "rxjs";
import { debounceTime, filter, map, observeOn, switchMap, take } from "rxjs/operators";

@Injectable({
	providedIn: "root",
})
export class CommonResponsibleGamingSelector {
	constructor(private messageSelector: MessageSelector) {}

	getSessionDuration() {
		return (state: CoreState): number => state.responsibleGaming.sessionDurationMinutes;
	}

	postLoginMessage$(messageFilter: MessageFilter) {
		const ignoredRoutes = [
			AUTH_ROUTE.login,
			CORE_ROUTE.registration.register,
			CORE_ROUTE.registration.registerSuccess,
		];

		return (state$: Observable<CoreState>): Observable<Message> =>
			state$.pipe(
				select(this.messageSelector.getFirst(messageFilter)),
				filter<Message>((message) => !!message),
				observeOn(asyncScheduler),
				switchMap((message) =>
					combineLatest([
						state$.pipe(select(RouteSelector.isNavigating)),
						state$.pipe(select(RouteSelector.getCurrent)),
					]).pipe(
						// wait until navigating or on ignored route
						filter(
							([isNavigating, current]) =>
								!isNavigating && !!current && !ignoredRoutes.includes(current.name)
						),
						debounceTime(1000),
						take(1),
						map(() => message)
					)
				)
			);
	}
}
